import type { ConsumerApiClient } from '../client';

export interface Announcement {
  id: string;
  title: string;
  body: string;
  type: 'info' | 'warning' | 'promotion' | 'maintenance';
  publishAt: string;
  expiresAt: string | null;
  createdAt: string;
}

export interface AnnouncementsApi {
  getAnnouncements(): Promise<Announcement[]>;
}

export function createAnnouncementsApi(client: ConsumerApiClient): AnnouncementsApi {
  return {
    getAnnouncements() {
      return client.get('/announcements');
    },
  };
}
